var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.75 1.833h.537c.243 0 .476.097.648.269l3.13 3.13a.92.92 0 0 1 .268.648v13.37c0 .506-.41.917-.916.917H4.583a.917.917 0 0 1-.916-.917V2.75c0-.506.41-.917.916-.917h9.167m-1.833 1.834v2.75c0 1.012.82 1.833 1.833 1.833h2.75v10.083h-11V3.667zm4.583 2.75h-2.75v-2.75h.157L16.5 6.259zm-8.25 8.25a.917.917 0 0 0 0 1.833h5.5a.917.917 0 0 0 0-1.833zm-.917-1.834c0-.506.41-.916.917-.916h5.5a.917.917 0 0 1 0 1.833h-5.5a.917.917 0 0 1-.917-.917m.917-3.666a.917.917 0 1 0 0 1.833h5.5a.917.917 0 0 0 0-1.833z",
    clipRule: "evenodd"
  })));
};
export default SvgDocument;